<template>
  <div>
     <div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>学习成绩查询</el-breadcrumb-item>
  <el-breadcrumb-item>作文成绩查询</el-breadcrumb-item>
</el-breadcrumb>
<el-card>
<el-row>
  <el-col :span="12"><div></div></el-col>
  <el-col :span="12"><div><el-button @click="getScore">成绩总揽</el-button></div></el-col>
</el-row>
 <el-table
    ref="multipleTable"
    :data="CorrectList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%">
    <!-- <el-table-column
      type="selection"
      width="55"
    >
    </el-table-column> -->
     <el-table-column
      prop="studentClass"
      :show-overflow-tooltip="true"
      label="班级"
      width="180">
    </el-table-column>

     <el-table-column
      prop="studentName"
      label="学生姓名"
      width="140">
    </el-table-column>
     <el-table-column
      prop="performance"
      label="分数"
      width="100">
    </el-table-column>
     <el-table-column
      prop="topic"
      label="题目"
      :show-overflow-tooltip="true"
      width="180">
    </el-table-column>
     <el-table-column
      prop="titel"
      label="作文号"
      width="180">
    </el-table-column>
     <el-table-column
      prop="source"
      label="来源"
      width="180">
    </el-table-column>
     <el-table-column
      prop="submitDate"
      label="提交时间"
      width="180">
    </el-table-column>
  </el-table>

</el-card>

<el-dialog
  :visible.sync="dialogVisible"
  width="80%"
  v-if="dialogVisible"
  destroy-on-close
>
 <ViewScoreEcharts :CorrectList="CorrectList"></ViewScoreEcharts>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>
    </div>
  </div>
</template>

<script>
import ViewScoreEcharts from '@/components/work/student/ViewScoreEcharts.vue'
export default {
  components:{ViewScoreEcharts},
    data(){
        return{
       infoList:[],
       CorrectList:[],
       dialogVisible:false,
        }
    },
    created(){
      this.getThroughByUserid()
    },
    methods:{
getThroughByUserid(){
  this.axios.post("excell/getCorrectById","studentNumert="+JSON.parse(localStorage.getItem("user")).studentID )
  .then(resp=>{
    if(resp.data.status==1){ 
      console.log(resp.data.result)
      this.CorrectList=resp.data.result
    }
  })
},getScore(){
  this.dialogVisible=true

}
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/student/CheckScore.vue